import * as React from "react";

const ChevronDown: React.FC = () => {
    return <svg width="12px" height="8px" viewBox="0 0 12 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-388.000000, -363.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(309.000000, 131.000000)">
                    <polygon points="10.6 2.25 6 6.95 1.4 2.25 0 3.65 6 9.75 12 3.65"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(ChevronDown);
